// extracted by mini-css-extract-plugin
export default {"container":"CK-z","disabled":"DK-z","bgBlack":"EK-z","content":"FK-z","countdown":"GK-z","topCaption":"HK-z","topHeading":"IK-z","heading":"JK-z","copy":"KK-z"};